import { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import packageSmsApis from '../../../../services/packageSmsApis';
import dayjs from 'dayjs';
import { IGetSummaryReportSMSResponse } from '../../interfaces/apis';
import reportApis, { SMSReportParams } from '../../../../services/reportApis';

const DEFAULT_PARAMS: SMSReportParams = {
  shopId: undefined,
  startDate: dayjs().subtract(7, 'day').startOf('day').format('MM-DD-YYYY'),
  endDate: dayjs().endOf('day').format('MM-DD-YYYY'),
};

const useGetSummaryReportSMS = () => {
  const [data, setData] = useState<IGetSummaryReportSMSResponse | null>(null);
  const [params, setParams] = useState(DEFAULT_PARAMS);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res: AxiosResponse<{ data: IGetSummaryReportSMSResponse }> = await reportApis.getSMSSummaryReportDashboard({
        shopId: params.shopId ? params.shopId : undefined,
        startDate: dayjs(params.startDate).format('MM-DD-YYYY'),
        endDate: dayjs(params.endDate).format('MM-DD-YYYY'),
      });
      setData(res?.data?.data);
    } catch (error) {
      console.error('Error fetching SMS package dashboard:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [params]);

  return { data, loading, params, setParams };
};

export default useGetSummaryReportSMS;
